// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

/**
 * Create linear falloff map
 * @param width Map width
 * @param height Map height
 * @returns Falloff map
 */
function generateFallOffMap(width: number, height: number): number[][] {
  const falloff: number[][] = [[]];

  for (let x = 0; x < width; x++) {
    falloff[x] = [];
    for (let y = 0; y < height; y++) {
      const i = (x / (width - 1)) * 2 - 1;
      const j = (y / (width - 1)) * 2 - 1;
      falloff[x][y] = 1 - Math.max(Math.abs(i), Math.abs(j));
    }
  }

  return falloff;
}

export { generateFallOffMap };
